import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { KioskService } from "src/app/core/services/kiosk.service";
import { Order } from "src/app/shared/models/order";

@Component({
	selector: "app-kiosk-order-status-display",
	templateUrl: "./kiosk-order-status-display.component.html",
	styleUrls: ["../../kiosk.styles.scss"],
})
export class KioskOrderStatusDisplayComponent implements OnInit {
	@Input() selectViewOrder: boolean;
	@Output() selectViewOrderChange = new EventEmitter<boolean>();

	activeOrder: Order;

	constructor(public kioskService: KioskService) {}

	ngOnInit(): void {
		console.log(`kiosk-order-status-display component ngOnInit`);
		this.activeOrder = this.kioskService.activeOrder.value;
		this.kioskService.activeOrder.subscribe((data) => {
			this.activeOrder = data;
		});
	}
}
